import EntityListView from '@/js/shared/components/dashboards/EntityListView';
import { AuthContext } from '@/store';
import { useNodeProps } from '@/node-editor/hooks';
import { INode, INodeProps } from '@/types/node';
import { Box } from '@mui/material';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { IContent } from './contract';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

interface IContainerStyleProps {
  override: Record<string, any>;
}

const useContainerStyles = ({ override }: IContainerStyleProps) => ({
  root: {
    width: '100% !important',
    ...override.root,
  },
});
export const Render = ({
  node: {
    id,
    override,
    content: { entityListId = '', minGridWith = 3 },
  },
  conferenceId,
}: IProps) => {
  const classes = useContainerStyles({
    override,
  });
  const { authState } = useContext(AuthContext);
  const [entityList, setEntityList] = useState<any>(null);

  useEffect(() => {
    if (entityListId) {
      axios.get(`/api/visitor/entitylists/${entityListId}`).then((response) => {
        setEntityList(response.data);
      });
    }
  }, [entityListId]);

  return (
    <Box sx={classes.root} {...useNodeProps(id)}>
      {authState.user ? (
        entityList ? (
          <EntityListView
            entityListId={entityListId}
            minGridWith={minGridWith}
          />
        ) : null
      ) : (
        <Box textAlign="center">{(window as any).LANG.AUTH_REQUIRED}</Box>
      )}
    </Box>
  );
};
